import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeaturedWorkImages, FeaturedWorkKey, ImageType } from "module/types";

// Define the initial state for the feature
interface FeaturedWorkImagesState {
  imageMap: Record<string, FeaturedWorkImages>;
  loading: boolean;
  error: string | null;
}

const initialState: FeaturedWorkImagesState = {
  imageMap: {},
  loading: false,
  error: null,
};

// Create the slice
const featuredWorkImagesSlice = createSlice({
  name: "featuredWorksImages",
  initialState,
  reducers: {
    setFeaturedWorkImages(
      state,
      action: PayloadAction<{ key: FeaturedWorkKey; images: ImageType[] }>
    ) {
      const { key, images } = action.payload;
      if (state.imageMap[key]) {
        state.imageMap[key].images = images;
      } else {
        state.imageMap[key] = {
          thumbnail: { url: "", orientation: "horizontal" },
          images,
        };
      }
      state.loading = false;
    },
    setFeaturedWorkThumbnails(
      state,
      action: PayloadAction<Record<FeaturedWorkKey, ImageType>>
    ) {
      const thumbnails = action.payload;
      Object.entries(thumbnails).forEach(([key, thumbnail]) => {
        if (state.imageMap[key]) {
          state.imageMap[key].thumbnail = thumbnail;
        } else {
          state.imageMap[key] = { thumbnail, images: [] };
        }
      });
      state.loading = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// Export actions
// export const { setFeaturedWorksImages, setLoading, setError } =
export const {
  setFeaturedWorkImages,
  setFeaturedWorkThumbnails,
  setLoading,
  setError,
} = featuredWorkImagesSlice.actions;

// Export the reducer
export const featuredWorkImagesReducer = featuredWorkImagesSlice.reducer;
